import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import VAFollowbackTab from '../VAFollowbackTab';
import { VpsPageHeader } from './vpsShared';

export default function VpsFollowback() {
  const { user } = useAuth();
  if (user?.role !== 'admin') {
    return <div className="text-sm text-gray-500">Admin access required.</div>;
  }

  return (
    <div className="space-y-6">
      <VpsPageHeader
        title="VPS Followback"
        subtitle="Scanner health for follows written by VPS automations."
      />
      <VAFollowbackTab />
    </div>
  );
}
